// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"_1UY-i___Header-module__headerContainer","spacer":"_1ub0x___Header-module__spacer","stickyContainer":"_35J44___Header-module__stickyContainer"};